<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
    contractStatus: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
    ...mapState('contract', { contractCurrent: 'current' }),
  },
  async created() {
    console.log(`KycMobileWooriCrowd status check ${this.resultName}`)

    if ((this.contractStatus === 'pending' || !this.contractStatus) && !this.me.mobileCarrier) {
      const path = '/auth/identity'  // 사장님 정보 받기
      if ([path].includes(this.$route.path) === false && this.routerStatusRedirect) {
        this.$router.replace(path)
      }
      return
    } else if (this.contractStatus === 'completed' && !this.me.kyc.mobileVerificationIsDone) {
      const path = '/kyc/verify-id/confirm' // 본인인증을 하시겠습니까?
      if (
        [path, '/kyc/verify-id'].includes(this.$route.path) === false &&
        this.routerStatusRedirect
      ) {
        this.$router.replace(path)
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
